/**
 * Helper de Feriados - Frontend
 * Lista de feriados 2025-2027 para validação visual
 * Criado em: 28/05/2026
 */

// Lista de feriados (mesmo conteúdo do backend)
const FERIADOS = {
  // 2025
  '2025-01-01': { nome: 'Confraternização Universal', tipo: 'federal' },
  '2025-03-03': { nome: 'Carnaval', tipo: 'federal' },
  '2025-03-04': { nome: 'Carnaval', tipo: 'federal' },
  '2025-04-18': { nome: 'Sexta-feira Santa', tipo: 'federal' },
  '2025-04-21': { nome: 'Tiradentes', tipo: 'federal' },
  '2025-05-01': { nome: 'Dia do Trabalho', tipo: 'federal' },
  '2025-06-19': { nome: 'Corpus Christi', tipo: 'federal' },
  '2025-07-09': { nome: 'Revolução Constitucionalista', tipo: 'estadual' },
  '2025-08-15': { nome: 'Aniversário de Sorocaba', tipo: 'municipal' },
  '2025-09-07': { nome: 'Independência do Brasil', tipo: 'federal' },
  '2025-10-12': { nome: 'Nossa Senhora Aparecida', tipo: 'federal' },
  '2025-11-02': { nome: 'Finados', tipo: 'federal' },
  '2025-11-15': { nome: 'Proclamação da República', tipo: 'federal' },
  '2025-11-20': { nome: 'Consciência Negra', tipo: 'federal' },
  '2025-12-25': { nome: 'Natal', tipo: 'federal' },
  
  // 2026
  '2026-01-01': { nome: 'Confraternização Universal', tipo: 'federal' },
  '2026-02-16': { nome: 'Carnaval', tipo: 'federal' },
  '2026-02-17': { nome: 'Carnaval', tipo: 'federal' },
  '2026-04-03': { nome: 'Sexta-feira Santa', tipo: 'federal' },
  '2026-04-21': { nome: 'Tiradentes', tipo: 'federal' },
  '2026-05-01': { nome: 'Dia do Trabalho', tipo: 'federal' },
  '2026-06-04': { nome: 'Corpus Christi', tipo: 'federal' },
  '2026-07-09': { nome: 'Revolução Constitucionalista', tipo: 'estadual' },
  '2026-08-15': { nome: 'Aniversário de Sorocaba', tipo: 'municipal' },
  '2026-09-07': { nome: 'Independência do Brasil', tipo: 'federal' },
  '2026-10-12': { nome: 'Nossa Senhora Aparecida', tipo: 'federal' },
  '2026-11-02': { nome: 'Finados', tipo: 'federal' },
  '2026-11-15': { nome: 'Proclamação da República', tipo: 'federal' },
  '2026-11-20': { nome: 'Consciência Negra', tipo: 'federal' },
  '2026-12-25': { nome: 'Natal', tipo: 'federal' },
  
  // 2027
  '2027-01-01': { nome: 'Confraternização Universal', tipo: 'federal' },
  '2027-02-08': { nome: 'Carnaval', tipo: 'federal' },
  '2027-02-09': { nome: 'Carnaval', tipo: 'federal' },
  '2027-03-26': { nome: 'Sexta-feira Santa', tipo: 'federal' },
  '2027-04-21': { nome: 'Tiradentes', tipo: 'federal' },
  '2027-05-01': { nome: 'Dia do Trabalho', tipo: 'federal' },
  '2027-05-27': { nome: 'Corpus Christi', tipo: 'federal' },
  '2027-07-09': { nome: 'Revolução Constitucionalista', tipo: 'estadual' },
  '2027-08-15': { nome: 'Aniversário de Sorocaba', tipo: 'municipal' },
  '2027-09-07': { nome: 'Independência do Brasil', tipo: 'federal' },
  '2027-10-12': { nome: 'Nossa Senhora Aparecida', tipo: 'federal' },
  '2027-11-02': { nome: 'Finados', tipo: 'federal' },
  '2027-11-15': { nome: 'Proclamação da República', tipo: 'federal' },
  '2027-11-20': { nome: 'Consciência Negra', tipo: 'federal' },
  '2027-12-25': { nome: 'Natal', tipo: 'federal' },
};

/**
 * Verifica se uma data é feriado
 * @param {Date} date - Data a verificar
 * @returns {Object|null} - { nome, tipo } se for feriado, null caso contrário
 */
export const verificarFeriado = (date) => {
  if (!date) return null;
  
  const key = date.toISOString().split('T')[0];
  return FERIADOS[key] || null;
};

/**
 * Retorna lista de todas as datas de feriados
 * @returns {string[]} - Array de datas no formato 'YYYY-MM-DD'
 */
export const getDatasFeriados = () => {
  return Object.keys(FERIADOS);
};

export default FERIADOS;
